/* eslint-disable react/jsx-pascal-case */
import { Col, Divider, Progress, Row, Space } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, Redirect, withRouter } from "react-router-dom";
import HomeBloc from "../../../bloc/home_bloc";
import RouteBloc from "../../../bloc/route_bloc";
import Config from "../../../Config";
import App_carousel_dashboard from "../../component/app_carousel_dashboard/app_carousel_dashboard";
import App_claim_status from "../../component/app_claim_status/app_claim_status";
import App_daterange_filter from "../../component/app_filters/app_daterange_filter";
import App_dropdown_filter from "../../component/app_filters/app_dropdown_filter";
import App_header from "../../component/app_header/app_header";
import App_news_card from "../../component/app_news_card/app_news_card";
import App_dashboard_header from "../../component/app_proposal_dashboard/app_dashboard_header";
import App_sidebar from "../../component/app_sidebar_mrtt/app_sidebar";
import "./mrtt_home_screen.css";
import GeneralBloc from "../../../bloc/general_bloc";
import { setFilterBy } from "../../../data/redux/reducers/filterReducer";
import { setUserData } from "../../../data/redux/reducers/userDataReducer";
import { setFilterBy1 } from "../../../data/redux/reducers/filterReducer1";
import { setSearchBy } from "../../../data/redux/reducers/searchByReducer";
import { setUserConfig } from "../../../data/redux/reducers/userConfigReducer";
import { setDTOverallFilter } from "../../../data/redux/reducers/dtOverallFilterReducer";
import { setDateFilter } from "../../../data/redux/reducers/dateFilterReducer";
import { setOverallListing } from "../../../data/redux/reducers/overallListingReducer";
import { setUpcomingListing } from "../../../data/redux/reducers/upcomingListingReducer";
import { setFilterDialog } from "../../../data/redux/reducers/filterDialogReducer";
import AppLoadingDialog from "../../dialog/app_loading_dialog";
import Base_screen from "../base/base_screen/base_screen";
import UserAccessBloc from "../../../bloc/user_access_bloc";
import App_daterange_filter_upcoming from "../../component/app_filters/app_daterange_filter_upcoming";
import App_claim_status_skeleton from "../../component/app_claim_status/app_claim_status_skeleton";
import AppFilterButtons from "../../component/app_filter_buttons/app_filter_buttons";
import AuthBloc from "../../../bloc/auth_bloc";
import App_dashboard_card from "../../component/app_dashboard_card/app_dashboard_card";
import AppDashboardList from "../../component/app_dashboard_list/app_dashboard_list";
import LanguageBloc from "../../../bloc/language_bloc";
import moment from "moment";

class mrttHomeScreen extends Component {
  constructor(props) {
    super(props);

    let routeParams = RouteBloc.extractRouteParamsFromProps(props);

    this.state = {
      client: Config.context,
      route: routeParams,
      proposalCount: null,
      issuedCasesCount: null,
      certificateCollectionCount: null,
      certificateCollectionCountUpcoming: null,
      claimsCount: null,
      businessOpportunitiesCount: null,
      businessOpportunitiesCountUpcoming: null,
      proposalCountData: [],
      quotationCountData: [],
      newsCardData: [],
      userData: [],
      carouselDummyData: [],
      carouselData: [],
      dateFilter: "",
      placeholderOverview: this.props.dateFilterGlobal?.overallDateValue
        ? this.props.dateFilterGlobal.overallDateValue
        : "",
      fromDate: "",
      toDate: "",
      dateFilter1: "",
      placeholderUpcoming: "",
      fromDate1: "",
      toDate1: "",
      loading: false,
      dateRangeOverall: {},
      dateRangeUpcoming: {},
      upcomingEventDropDown: {},
      issuedCaseTitle: "",
      dashboardListing: this.props.dateFilterGlobal,
    };
  }


  componentDidMount() {
    

    // this.init(); //remember to remove

  }

  async init() {
    let userData = await UserAccessBloc.getUserData();
    let name = "";
    let role = "";
    let branch = "";
    if (userData) {
      name = userData ? userData.displayName : "";
      role = userData ? userData.designationTitle : "";
      this.setState({
        userData: userData,
        userDataHeader: HomeBloc.getUserData(name, role, branch),
      });
    }

    this.setState({
      loading: true,
    });
    // use this instead to get username -> this.state.userData.username
    let username = userData.username //'SHA002'
    let dashboardCount = HomeBloc.getDashboardOverviewCountData(username);
    let pendingSubmissionData = HomeBloc.getDashboardPendingSubmission(username);
    let recentActivityData = await HomeBloc.getDashboardRecentActivities(username);
    let progressCountData = HomeBloc.getDashboardProgressCount(username);
    console.log("see pending: ", await pendingSubmissionData);
    // let userData = this.props.userDataGlobal.data;
    this.setState({
      pendingSubmissionData: await pendingSubmissionData,
      recentActivityData: await recentActivityData,
      proposalCountData: (await dashboardCount).proposal,
      quotationCountData: (await dashboardCount).quotation,
      progressCountData: await progressCountData,
      // userData: userData,
      loading: false
    });
  }

  handleGoDashboard(module, status) {
    if (module == 'quotation') {
      window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation}/${status}`
    } else {
      window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal}/${status}`
    }
  }

  renderHeaderContents() {
    let proposalTitle = this.state.proposalCountData[0] ? this.state.proposalCountData[0].category : null
    let quotationTitle = this.state.quotationCountData[0] ? this.state.quotationCountData[0].category : null
    let submittedProposal = this.state.proposalCountData?.submitted ? this.state.proposalCountData?.submitted[0] : null
    let pendingProposal = this.state.proposalCountData ? this.state.proposalCountData?.pendingCount : null
    let proposalProceeded = this.state.quotationCountData?.proposalProceeded ? this.state.quotationCountData?.proposalProceeded[0] : null
    let initiatedProposal = this.state.quotationCountData ? this.state.quotationCountData?.initiatedCount : null

    return (
      <div className="mrtt_homescreen__main_content">
        <div >
          {this.state.loading && this.loadingContent()}
          <div className="mrtt_homescreen__header w-100">
            <div className="mrtt_homescreen__welcome-title">
              Hello {this.state.userData?.displayName || 'N/A'} !
            </div>
          </div>
          <div className="mrtt_homescreen__subtitle w-100 mt-1">
            Here is what happening in your dashboard today.
          </div>

          <div className="mrtt_homescreen__title " style={{ marginBlock: '4.5vh' }}>Application Statuses</div>
          <div className="w-100 ">
            <div className="mrtt_homescreen__section_title w-100">
              {proposalTitle ? LanguageBloc.getTextForLocale(proposalTitle) : 'Proposal'}
            </div>
            <div className="mrtt_homescreen__proposal_container mt-2 ">
              {
                submittedProposal &&
                <App_dashboard_card
                  cardTitle={LanguageBloc.getTextForLocale(submittedProposal.title)}
                  cardValue={submittedProposal.count}
                  backgroundColor={submittedProposal.color}
                  status={submittedProposal.status}
                  module={'proposal'}
                  onClick={() => this.handleGoDashboard('proposal', submittedProposal.status)}
                />
              }
              {
                pendingProposal != null &&
                <App_dashboard_card
                  cardTitle={'Pending'}
                  cardValue={pendingProposal}
                  backgroundColor={'#FEDEDE'}
                  status={'PENDING'}
                  module={'proposal'}
                  onClick={() => this.handleGoDashboard('proposal', 'PENDING')}
                />
              }
            </div>
          </div>
          <div className="w-100 mt-4">
            <div className="mrtt_homescreen__section_title w-100">
              {quotationTitle ? LanguageBloc.getTextForLocale(quotationTitle) : 'Quotation'}
            </div>
            <div className="mrtt_homescreen__proposal_container mt-2 ">
              {
                proposalProceeded &&
                <App_dashboard_card
                  cardTitle={LanguageBloc.getTextForLocale(proposalProceeded.title)}
                  cardValue={proposalProceeded.count}
                  status={proposalProceeded.status}
                  module={'quotation'}
                  onClick={() => this.handleGoDashboard('quotation', proposalProceeded.status)}
                />
              }
              {
                initiatedProposal != null &&
                <App_dashboard_card
                  cardTitle={'Initiated'}
                  cardValue={initiatedProposal}
                  backgroundColor={'#F9E5D8'}
                  status={'INITIATED'}
                  module={'quotation'}
                  onClick={() => this.handleGoDashboard('quotation', 'INITIATED')}
                />
              }
            </div>
          </div>
          <Divider className=" dashboard_divider" />
          <div className="w-100">
            <div className="mrtt_homescreen__title my-4">
              Pending
            </div>
            <div className="mrtt_homescreen__pending_list_container  p-3">
              {
                this.state.pendingSubmissionData && this.state.pendingSubmissionData.length > 0 ?
                  this.state.pendingSubmissionData.map((item, idx) => {
                    return (
                      <AppDashboardList
                        index={idx + 1}
                        name={item.proposal_attr.properties.name}
                        refNo={item.proposal.refNo}
                        id={item.proposal.id}
                        idNo={item.proposal_attr.properties.idNo || item.proposal_attr.properties.otherIdNo || 'N/A'}
                        lastUpdate={moment(item.proposal.cms_updatedOn).format("DD/MM/YYYY")}
                        // module={item.user_activity.title === 'Quotation.' ? 'quotation' : 'proposal'}
                        status={item.proposal.trxStatus || 'DRAFT'}
                        backgroundColor={'#FDF4DE'}
                        textColor={'#EEBB3D'}
                        lastIndex={this.state.pendingSubmissionData.length === idx + 1 ? true : false}
                        props={this.props}
                      />
                    )
                  })
                  : <div className="mrtt_homescreen__subtitle">No Data</div>
              }
            </div>
          </div>
          <Divider className="dashboard_divider" />
          <div className="w-100">
            <div className="mrtt_homescreen__title my-4">
              Recent Activities
            </div>
            <div className="mrtt_homescreen__pending_list_container p-3">
              {
                this.state.recentActivityData && this.state.recentActivityData.length > 0 ?
                  this.state.recentActivityData.map((item, idx) => {
                    return (
                      <AppDashboardList
                        index={idx + 1}
                        name={item.user_activity.userId}
                        refNo={item.user_activity.properties.refNo}
                        id={item.user_activity.properties?.quotationId || item.user_activity.properties?.proposalId}
                        idNo={item.user_activity.properties.idNo || 'N/A'}
                        lastUpdate={moment(item.activityTimestamp).format("DD/MM/YYYY")}
                        module={item.user_activity.title === 'Quotation.' ? 'quotation' : 'proposal'}
                        status={item.user_activity.properties.trxStatus || 'DRAFT'}
                        backgroundColor={'#FDF4DE'}
                        textColor={'#EEBB3D'}
                        lastIndex={this.state.recentActivityData.length === idx + 1 ? true : false}
                        props={this.props}
                      />
                    )
                  })
                  : <div className="mrtt_homescreen__subtitle">No Data</div>
              }

            </div>
          </div>
        </div>
      </div>
    );
  }

  renderProposalProgress() {
    let submittedProposal = this.state.proposalCountData?.submitted ? this.state.proposalCountData?.submitted[0] : null
    let pendingProposal = this.state.proposalCountData ? this.state.proposalCountData?.pendingCount : null
    let total = submittedProposal && pendingProposal != null ? submittedProposal.count + pendingProposal : 'N/A';

    return (
      <>
        <div className="mrtt_homescreen__header w-100">
          <div className="mrtt_homescreen__title">
            Track proposal progress
          </div>
        </div>
        <div className="mt-4">
          {
            this.state.progressCountData && this.state.progressCountData.map((progress) => {
              return (
                <>
                  <div className="d-flex justify-content-between mt-4">
                    <div className="mrtt_homescreen__progress_title">{LanguageBloc.getTextForLocale(progress.title)}</div>
                    <div className="mrtt_homescreen__progress_value">{progress.count}/{total}</div>
                  </div>
                  <Progress percent={(progress.count / total) * 100} showInfo={false} strokeColor={progress.color} size="small" />
                </>
              )
            })
          }
        </div>
      </>
    )
  }

  loadingContent() {
    return (
      <div style={{ height: "100%", width: "100%" }}>
        <AppLoadingDialog isLoading={this.state.loading} />
      </div>
    );
  }

  render() {
    return (
      <>
        <Base_screen
          // loading={this.state.loading}
          entity={this.state.route.entity}
          listener={() => {
            this.init();
          }}
        >
          {this.props.userGlobal ? (
            <div className="mrtt_homescreen d-flex" style={{ border: '1px solid rgba(224, 224, 224, 1)' }}>
              <div className="w-75">
                <App_header
                  data={this.state.userData}
                  route={this.state.route.entity}
                />
                <App_sidebar
                  route={this.state.route.entity}
                  onLinkClick={() => {
                    this.props.setOverallListing({
                      overallDateValue: null,
                    });
                  }}
                >
                  {this.renderHeaderContents()}
                </App_sidebar>
              </div>
              <div className="w-25 mrtt_homescreen__track_progress_container">
                {this.renderProposalProgress()}
              </div>
            </div>

          ) : (
            <Redirect
              to={`/${this.state.client}/${Config.routes.generic.login}`}
            />
          )}
        </Base_screen>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
    userDataGlobal: state.userData.value,
    dtOverallFilterGlobal: state.dtOverallFilter.value,
    dateFilterGlobal: state.dateFilter.value,
    dialogFilterGlobal: state.filterDialog.value,
    overallListingGlobal: state.overallListing.value,
    upcomingListingGlobal: state.upcomingListing.value,

    //globalFilterByUpcoming: state.filter1.value,
  };
};

const mapDispatchToProps = {
  setFilterBy,
  setSearchBy,
  setFilterBy1,
  setUserData,
  setUserConfig,
  setDTOverallFilter,
  setDateFilter,
  setOverallListing,
  setUpcomingListing,
  setFilterDialog,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(mrttHomeScreen)
);

// export default withRouter(homeScreen);
